export const PATH = {
    LOGIN: '/',
    FORGOTPASSWORD: '/forgotpassword',
    MOBILELOGIN: '/mobilelogin',
    REGISTRATION: '/registration',
    VERIFYEMAIL:'/activate/:token',
    RESETPASSWORD: '/reset-password/:token',
    VERIFYOTP: '/verifyotp',
    PROFILESETUP:'/profileSetup',
    PROFILEPREVIEW:'/profilePreview',
    LANDINGPAGE: '/landingpage',
    VENDORDASHBOARD:'/vendordashboard',
    DEFAULT: '*'
}